export default __webpack_public_path__ + "static/media/team_speer.3835ed1d.svg";